import UserKYCForm from './UserKYCForm';

export default UserKYCForm;
